import { ILicenseDTO } from 'app/shared/services/license.service';
import { getUTCDate, Entity, Key } from '@kpd/framework-ngx';

const notYetValid = 'NotYetValid';
const noLongerValid = 'NoLongerValid';
const invalid = 'Invalid';

export class License extends Entity {
  key: Key<string>;
  quantity: number;
  quantityAssigned: number;
  clientIds: string[];
  purchaseDateTime: Date;
  validFromDateTime: Date;
  validUntilDateTime: Date;
  licenseId: string;
  name: string;
  applications: {
    name: string;
    description?: string;
    version?: string;
  }[];

  get applicationNames(): string {
    if (!this.applications) return '';
    return this.applications.map((a) => a.name).join(', ') + ' ';
  }

  state: string[] = [];

  get isFuture(): boolean {
    return this.state.some((s) => s === notYetValid);
  }
  get isExpired(): boolean {
    return this.state.some((s) => s === noLongerValid);
  }
  get isInvalid(): boolean {
    return this.state.some((s) => s === invalid);
  }

  constructor(dto?: ILicenseDTO) {
    super(dto);
    if (dto) {
      this.purchaseDateTime = new Date(dto.purchaseDateTime);
      this.validFromDateTime = new Date(dto.validFromDateTime);
      this.validUntilDateTime = new Date(dto.validUntilDateTime);
      if (dto.state && typeof dto.state === 'string') {
        this.state = dto.state.split(', ');
      }
    }
  }

  setKey(dto: any): void {
    this.key = new Key(dto.licenseId);
  }

  clone(): License {
    const clone = new License();
    Object.assign(clone, this);
    return clone;
  }

  get quantityAvailable(): number {
    return this.quantity - this.quantityAssigned;
  }

  get isExpiring(): boolean {
    return this.getValidTermInDays() < 30;
  }

  get isOutofbounds(): boolean {
    return this.quantityAssigned > this.quantity;
  }

  get isUsedup(): boolean {
    return this.quantityAvailable === 0;
  }

  get purchaseDate(): number {
    return this.purchaseDateTime.setHours(0, 0, 0);
  }

  get validFromDate(): number {
    return this.validFromDateTime.setHours(0, 0, 0);
  }

  get validUntilDate(): number {
    return this.validUntilDateTime.setHours(0, 0, 0);
  }

  getDisplayName(): string {
    return this.name || '';
  }

  getValidTermInDays(): number {
    if (!this.validUntilDateTime || !this.validFromDateTime) {
      return 0;
    }
    const diff = getUTCDate(this.validUntilDateTime).valueOf() - getUTCDate(new Date()).valueOf();
    return Math.round(diff / (1000 * 60 * 60 * 24)) + 1;
  }

  getDetailUrl(): string {
    return `/licenses/details/license/${this.licenseId}?tab=users`;
  }
}
